import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BatteryCharging } from 'lucide-react';
export function Proof() {
  return <section className="py-24 px-4 bg-offwhite" data-id="element-285">
      <div className="max-w-3xl mx-auto" data-id="element-286">
        <FadeIn data-id="element-287">
          <div className="bg-white border border-sage p-8 sm:p-12 rounded-3xl shadow-lg relative" data-id="element-288">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-amber text-forest p-3 rounded-full shadow-md" data-id="element-289">
              <BatteryCharging size={32} data-id="element-290" />
            </div>

            <h2 className="font-serif text-2xl sm:text-3xl font-bold text-forest mb-8 text-center mt-4" data-id="element-291">
              Lo que cambia en 21 días
            </h2>

            <div className="space-y-6 text-lg text-charcoal/80 leading-relaxed" data-id="element-292">
              <p data-id="element-293">
                <strong className="text-forest" data-id="element-294">
                  La irritabilidad desaparece.
                </strong>{' '}
                Dejas de "arrastrarte" por la oficina.
              </p>
              <p data-id="element-295">
                <strong className="text-forest" data-id="element-296">
                  Tu sueño se vuelve verdaderamente reparador
                </strong>{' '}
                porque tu sistema nervioso tiene los minerales para
                desconectarse.
              </p>
              <div className="p-6 bg-sage/30 rounded-xl mt-8 border-l-4 border-forest" data-id="element-297">
                <p className="font-medium text-forest m-0" data-id="element-298">
                  Al final de las 3 semanas, habrás establecido una nueva "línea
                  base" de energía que no depende de nada externo.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}